import "./App.css";
import "antd/dist/antd.css";
import React, { useEffect } from "react";
import PublicRoute from "./components/PublicRoute";
import PrivateRoute from "./components/PrivateRoute";
import { Route, Switch } from "react-router-dom";
import Login from "./container/Login/Login";
import ForgotPassword from "./container/ForgotPassword/ForgotPassword";
import Register from "./container/Register/Register";
import Main from "./container/Main/Main";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import NoPageFound from "./components/NoPageFound";
import vCard from "./container/vCard/vCard";
import Test from "./components/Test";
import Authorization from "./container/Authorization";

import history from "./hooks/history";
import ReactJoyRide from "./userguiders/ReactJoyRide";

const App = () => {
  useEffect(() => {
    console.log(
      "%cDesigned and Developed by Techoid.co -> https://techoid.co ",
      "color: yellow; font-size: 24px"
    );
  }, []);
  return (
    <Provider store={store}>
      <BrowserRouter history={history}>
        <ReactJoyRide />
        <Switch>
          <PublicRoute exact path="/" component={Login} />
          <PublicRoute exact path="/login-page2" component={Login} />
          <PublicRoute exact path="/register" component={Register} />
          <PublicRoute exact path="/test" component={Test} />
          <PublicRoute exact path="/authorization" component={Authorization} />
          <PublicRoute
            exact
            path="/forgotPassword/:id/:token"
            component={ForgotPassword}
          />
          <Route exact path={["/wc/:id", "/wc//wc/:id"]} component={vCard} />

          <PrivateRoute path="/app" component={() => <Main />} />
          <PrivateRoute path="*" component={NoPageFound} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
